/** Locale message bundles. Extend with per-lang modules as needed. */
const messages: Record<string, { translation: Record<string, string> }> = {
  en: { translation: {} },
};

export default messages;
